import type { CanvasInsertionObject } from "./types";

/** 失败卡和后处理结果保留在画布参与腾位，但不能成为底部生图参考点。 */
export function isBottomGenerationAnchor(obj: CanvasInsertionObject): boolean {
  const status = obj.placeholderStatus ?? obj.data?.originalObj?.placeholderStatus;
  return status !== "failed" && status !== "review_failed" &&
    obj.isPostProcessResult !== true &&
    obj._preserveGlobalReferenceAnchor !== true &&
    obj.data?.originalObj?.isPostProcessResult !== true &&
    obj.data?.originalObj?._preserveGlobalReferenceAnchor !== true;
}
